import { Grid, Elements } from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { injectIntl, useIntl, WrappedComponentProps } from 'react-intl'
import Attachments from '../../common/attachments/Attachments'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import Instructions from '../../common/instructions/Instructions'
import { ApprovalUnderReviewViewModel } from '../../ViewModels'

import AdditionalInformation from '../../common/attachments/AdditionalInformation'
import SignedDocuments from '../../common/attachments/SignedDocuments'
import './ApprovalUnderReview.scss'

const { Paragraph } = Elements

type ApprovalUnderReviewProps =  ApprovalUnderReviewViewModel;

const ApprovalUnderReview: React.FunctionComponent<ApprovalUnderReviewProps &
	WrappedComponentProps> = props => {
	const {companyName, canAttachFile, canAttachAdditionalInformation } = props
	const intl = useIntl()

	return (
		<React.Fragment>
			<Grid.GridWrapper className="IndividualView approval-under-review">
				<IndividualHeader
					companyName={companyName}
					headingId="approvalUnderReview.heading"
					preambleId="approvalUnderReview.body"
					preambleData={{
						companyName: companyName,
					}}
				/>

				{props.instructions && <Instructions {...props} />}		
				<SignedDocuments {...props} />
				{(canAttachFile || canAttachAdditionalInformation) && <Paragraph className='paragraph'>{intl.formatMessage({ id: 'requireAttachments.additional-information.header' })}</Paragraph>}
				{canAttachFile && <Attachments {...props} />}
				{canAttachAdditionalInformation && <AdditionalInformation orderId={props.orderId} body={props.additionalInformation} />}
			</Grid.GridWrapper>
		</React.Fragment>
	)
}

export default injectIntl(observer(ApprovalUnderReview))
